module.exports = __webpack_public_path__ + "static/vision_and_strategy_development-c374a8be5609545330faf9d6f6c0e1d3.jpg";